import React from 'react';

const LETTERS = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ');

/**
 * The A–Z "Browse by letter" control every list page carries (02b:95).
 *
 * Platform, not per-Family: it filters on the name register, which every family
 * declares, so it needs no metadata. The `alphabetical-button` /
 * `alphabetical-button-active` classes are the shipped markup, and the e2e
 * nav-contract's N3 step reads that active class — Skills' drift to raw utility
 * classes is what allowlist A23 records, and this uniform markup is what fixes
 * it.
 */
export default function LetterFilter({ value, onChange }) {
  const button = (letter, label) => (
    <button
      key={label}
      type="button"
      onClick={() => onChange(letter)}
      aria-pressed={value === letter}
      className={`alphabetical-button ${
        value === letter ? 'alphabetical-button-active' : 'alphabetical-button-inactive'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="alphabetical-filter">
      {/* A heading for a group of buttons, not a form label — an orphan
          <label> has nothing to label (#313). */}
      <span className="filter-label" id="letter-filter-label">Browse by letter</span>
      <div className="alphabetical-buttons" role="group" aria-labelledby="letter-filter-label">
        {button('', 'All')}
        {LETTERS.map((letter) => button(letter, letter))}
      </div>
    </div>
  );
}
